<script>
    import { SendRequest } from "./APIService";
    import { showModal } from "./Modal";

    let users = [];
    let inputText = "";

    function getAllUsers(userName) {
        SendRequest(
            "GetUsersByName",
            "POST",
            "userName=" + userName,
            (response) => {
                users = response;
            },
            (error) => {
                showModal("Error", "Users not found", "OK");
            },
        );
    }

    function onKeyDown(e) {
        if (inputText == "") {
            return;
        }
        switch (e.keyCode) {
            case 13:
                getAllUsers(inputText);
                break;
        }
    }
</script>

<div class="card col-md-12">
    <h5 class="card-header"><h3>Find</h3></h5>
    <div class="card-body">
        <div class="input-group mb-3">
            <input type="text" class="form-control" bind:value={inputText} />
            <div class="input-group-append">
                <button
                    class="w-100 btn btn-lg btn-primary"
                    on:click={getAllUsers(inputText)}>Get</button
                >
            </div>
        </div>
    </div>
</div>

{#if users.length <= 0}
    <h4 style="color: white;">No Data Yet</h4>
{:else}
    <div
        style="margin-bottom:30px; border:1px solid #ccc; padding:10px; border-radius:8px;"
    >
        <table
            class="table table-bordered table-hover"
            style="margin-top:10px;"
        >
            <thead>
                <tr>
                    <th>User ID</th>
                    <th>User Name</th>
                    <th>Level</th>
                    <th>Has Vip Bundle</th>
                    <th>Clan Id</th>
                    <th>Clan Name</th>
                    <th>Clan Badge Id</th>
                </tr>
            </thead>
            <tbody>
                {#each users as user}
                    <tr>
                        <td>{user.userId}</td>
                        <td>{user.nickName}</td>
                        <td>{user.level}</td>
                        <td>{user.hasVipBundle}</td>
                        <td>{user.clanId}</td>
                        <td>{user.clanName}</td>
                        <td>{user.clanBadgeId}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
{/if}

<svelte:window on:keydown={onKeyDown} />
